import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeSsoCode } from '../lib/auth-client';
import { useAuth } from '../context/AuthContext';

/**
 * Callback từ ERP Base SSO. URL: /sso/callback?code=xxx&state=yyy
 * Đổi code lấy session token → set user context → redirect /dashboard.
 */
export function SsoCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) {
      setError('Thiếu code hoặc state trong URL callback.');
      return;
    }

    (async () => {
      try {
        const user = await exchangeSsoCode(code, state);
        setUser(user);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        setError((err as Error).message);
      }
    })();
  }, [params, navigate, setUser]);

  if (error) {
    return (
      <div className="sso-error">
        <h2>Lỗi đăng nhập SSO</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/login', { replace: true })}>Thử lại</button>
      </div>
    );
  }

  return (
    <div className="sso-loading">
      <div className="spinner" />
      <p>Đang xử lý đăng nhập...</p>
    </div>
  );
}
